import { getAllMedia } from "../../api/apiHandler";
import React, { useEffect, useState } from "react";
import heroImg from "../../Assets/images/gettyimg.jpg";

const getEmbedUrl = (url) => {
  if (!url) return "";

  const match = url.match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  );
  if (match) return `https://www.youtube.com/embed/${match[1]}`;

  return url.includes("youtube.com/") || url.includes("youtu.be") ? "" : url;
};


const Videos = () => {
  const [dynamicVideos, setDynamicVideos] = useState([]);

  // 🔥 Fetch admin-added videos
  useEffect(() => {
    getAllMedia()
      .then((res) => {
        if (Array.isArray(res.data)) {
          setDynamicVideos(res.data);
        }
      })
      .catch((err) => console.error("Video fetch error:", err));
  }, []);

  const allVideos = dynamicVideos.map((v) => ({
    id: v.id,
    title: v.title,
    url: getEmbedUrl(v.url),
  }));

  return (
    <section>
      {/* HERO */}
      <div className="relative h-[340px] w-full">
       <img
  src={heroImg}
  alt="Photo Gallery"
  className="w-full h-full object-cover"
/>

        <div className="absolute inset-0 bg-black/70 flex flex-col items-center justify-center text-white">
          <h1 className="text-4xl font-bold">Video Gallery</h1>
          <p className="mt-3 text-gray-300 text-sm max-w-xl text-center">
            Ground reports, interviews & real stories
          </p>
        </div>
      </div>

      {/* VIDEOS */}
      <div className="py-20 max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16">

          {allVideos.map((video) => (
            <div
              key={video.id}
              className="bg-white rounded-3xl shadow-2xl p-2 transition hover:-translate-y-2"
            >
              <div className="relative w-full aspect-video bg-black rounded-2xl overflow-hidden">
                <iframe
                  src={getEmbedUrl(video.url)}
                  title={video.title}
                  className="absolute inset-0 w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>

              <div className="p-3 text-center">
                <h3 className="text-lg font-semibold text-slate-900">
                  {video.title}
                </h3>
              </div>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default Videos;
